// Row fields the queue and the review panel must agree on. Their own module so the panel
// can share them without importing its parent.

export const rec = r => r.record || {};
export const sub = r => r.submission || {};

// An initial earns a dot, a bare first name does not: plenty of students have no surname
// on record, and "Pawar." reads as a cut rather than an abbreviation.
const named = (firstName, lastInitial) =>
  lastInitial ? `${firstName} ${lastInitial}.` : firstName;

// Assembled card, then a name an admin typed, then the one the API resolved. A lookup
// never overrides a human.
export const displayName = r => {
  if (rec(r).name) return rec(r).name;
  const s = sub(r);
  if (s.firstName) return named(s.firstName, s.lastInitial);
  const { firstName, lastInitial } = r.student || {};
  return firstName ? named(firstName, lastInitial) : null;
};

export const gradeAndState = r => {
  const source = rec(r).grade || rec(r).state ? rec(r) : sub(r);
  const grade = source.grade || (r.student || {}).grade;
  return [grade ? `Grade ${grade}` : null, source.state].filter(Boolean).join(' · ');
};

// Someone's own prose off a row, or '' when there is none. Tolerates an array because
// `record.narrative` is one and the note fields sit one word away from it.
const noteText = value => {
  if (Array.isArray(value)) return value.filter(Boolean).join('\n\n');
  return typeof value === 'string' ? value.trim() : '';
};

// The tutor's journey note. It arrives as `narrative` on the *submission*, which is a
// different thing from `record.narrative`: that one is card copy the assemble agent
// generates. The note is deliberately never published, so the review drawer is the only
// place it is ever read — anywhere else and it would be nowhere.
export const tutorNote = r => noteText(sub(r).narrative);

// The parent's note, written in the App's claim form and sent with their consent. Stored in
// `meta` rather than on the record for the same reason the tutor's is not published: it is
// context for the moderator deciding, not copy for the card.
export const parentNote = r => noteText(r.parent_note);

// The tutor's proof for an off-list achievement -- never published, drawer-only.
//
// Assumes webbackend#90's contract, which this ships ahead of: `evidence` is present only
// when a file is actually stored, and `url` is a short-lived signed link whose null means
// signing failed -- never "no evidence". Both branches of the panel below depend on that.
// The server also sends `source` (tutor vs admin upload) and `attachedAfterReview`;
// neither is surfaced yet, so neither is carried here.
export const tutorEvidence = r => {
  const entry = r && r.evidence;
  if (!entry || typeof entry !== 'object') return null;
  const url = typeof entry.url === 'string' && entry.url ? entry.url : null;
  return { url, uploadedAt: entry.uploadedAt || null };
};
